var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLamp1OffDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(7 3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M10 5.006C9.982 2.242 7.746 0 5 0S.018 2.242 0 5.006v.033c.01 2.012.849 3.126 1.59 4.11.62.822 1.11 1.471 1.11 2.553v1.54c0 .97.783 1.758 1.744 1.758h1.112c.961 0 1.744-.789 1.744-1.758v-1.54c0-1.082.49-1.731 1.11-2.554C9.15 8.165 9.99 7.051 10 5.04v-.033zm-3.863 8.236c0 .323-.26.586-.581.586H4.444c-.32 0-.581-.263-.581-.586V12.1h2.274v1.142zM5 16c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zM5 1.172c2.11 0 3.83 1.727 3.837 3.852-.005 1.627-.66 2.496-1.353 3.415-.538.714-1.091 1.447-1.28 2.489H3.795c-.188-1.042-.74-1.775-1.279-2.489-.693-.92-1.348-1.788-1.353-3.415C1.17 2.9 2.889 1.172 5 1.172z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp1OffDark);
export default __webpack_public_path__ + "static/media/lamp-1-off-dark.5670dcb07114b20dd4d672731871b9c0.svg";
export { ForwardRef as ReactComponent };